import cn from 'clsx';
import { PropsWithChildren } from 'react';

interface BasicBadgeProps extends PropsWithChildren {
  readonly extraClassName: string;
}

export function BasicBadge({ extraClassName, children }: BasicBadgeProps) {
  return (
    <span className={cn('rounded border px-xs text-xs', extraClassName)}>
      {children}
    </span>
  );
}
